<div class="page-content">
    <div class="page-header section">
        <h1>{{ title }}</h1>
        <div class="page-description">{{ subTitle }}</div>
    </div>

    <div class="page-body">
        <div class="cards-container">
            <div class="row section">
                <div class="col-sm-12 col-md-6">
                    <generic-card title="Séléction de l'indicateur">
                        <div class="selectindicator">
                            <ed-select
                                id="selectIndicator"
                                class="selectindicator"
                                [options]="indicators"
                                [ngModel]="currentIndicator().value"
                                (ngModelChange)="updateCurrentIndicator($event)">
                            </ed-select>
                        </div>
                    </generic-card>
                </div>
                <div class="col-sm-12 col-md-6">
                    <generic-card
                        [isLoading]="cracMapData().length == 0"
                        [error]="cracMapData()[0] && cracMapData()[0].error == true">
                        <span class="text-explain">
                            {{ explanationText }}
                        </span>
                    </generic-card>
                </div>
            </div>
            <div class="row section">
                <div class="col-sm-12 col-md-5">
                    <geo-map-card
                        title="{{ currentIndicator().label }}   ({{ currentIndicator().unit }})"
                        [geometries]="metropolitanGeometries()"
                        [isLoading]="cracMapData().length == 0"
                        [error]="cracMapData()[0] && cracMapData()[0].error == true"
                        [getStyle]="getMapStyle"
                        [mapId]="'FranceMap'"
                        [getTooltip]="getTooltip"
                        [baseMapUrl]="baseMapUrl"
                        [downloadable]="false"
                        [height]="size1">
                    </geo-map-card>
                </div>
                <div class="col-sm-12 col-md-7">
                    <div class="row">
                        <div class="col-sm-12 col-md-3">
                            <div class="row">
                                <div class="col-sm-12">
                                    <generic-card title="Légende">
                                        <div class="legend-cracmap">
                                            @for (
                                                legend of currentIndicator().legendConfig;
                                                track legend.value
                                            ) {
                                                <div class="legenditem">
                                                    <i
                                                        [style]="{
                                                            'background-color': legend.color,
                                                        }"></i
                                                    >{{ legend.value }}
                                                </div>
                                            }
                                        </div>
                                    </generic-card>
                                </div>
                            </div>
                            <div class="gap"></div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <geo-map-card
                                        title="Guadeloupe"
                                        [geometries]="guadeloupeGeometries()"
                                        [isLoading]="cracMapData().length == 0"
                                        [error]="guadeloupeGeometries().length === 0"
                                        [getStyle]="getMapStyle"
                                        [mapId]="'GuadeloupeMapId'"
                                        [getTooltip]="getTooltip"
                                        [zoomable]="false"
                                        [downloadable]="false"
                                        [baseMapUrl]="baseMapUrl"
                                        [height]="size3">
                                    </geo-map-card>
                                </div>
                            </div>
                            <div class="gap"></div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <geo-map-card
                                        title="Martinique"
                                        [geometries]="martiniqueGeometries()"
                                        [isLoading]="cracMapData().length == 0"
                                        [error]="martiniqueGeometries().length === 0"
                                        [getStyle]="getMapStyle"
                                        [mapId]="'MartiniqueMapId'"
                                        [getTooltip]="getTooltip"
                                        [zoomable]="false"
                                        [downloadable]="false"
                                        [baseMapUrl]="baseMapUrl"
                                        [height]="size3">
                                    </geo-map-card>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <div class="row">
                                <div class="col-sm-12">
                                    <geo-map-card
                                        title="Paris"
                                        [geometries]="metropolitanGeometries()"
                                        [isLoading]="cracMapData().length == 0"
                                        [error]="cracMapData()[0] && cracMapData()[0].error == true"
                                        [getStyle]="getMapStyle"
                                        [mapId]="'Paris'"
                                        [getTooltip]="getTooltip"
                                        [baseMapUrl]="baseMapUrl"
                                        [downloadable]="false"
                                        [center]="centerParis"
                                        [height]="size2">
                                    </geo-map-card>
                                </div>
                            </div>
                            <div class="gap"></div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <geo-map-card
                                        title="Lyon"
                                        [geometries]="metropolitanGeometries()"
                                        [isLoading]="cracMapData().length == 0"
                                        [error]="cracMapData()[0] && cracMapData()[0].error == true"
                                        [getStyle]="getMapStyle"
                                        [mapId]="'Lyon'"
                                        [getTooltip]="getTooltip"
                                        [baseMapUrl]="baseMapUrl"
                                        [center]="centerLyon"
                                        [downloadable]="false"
                                        [height]="size2">
                                    </geo-map-card>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-3">
                            <div class="row">
                                <div class="col-sm-12">
                                    <geo-map-card
                                        title="Corse"
                                        [mapId]="'CorseMapId'"
                                        [geometries]="corseGeometries()"
                                        [isLoading]="cracMapData().length == 0"
                                        [error]="corseGeometries().length === 0"
                                        [getStyle]="getMapStyle"
                                        [getTooltip]="getTooltip"
                                        [zoomable]="false"
                                        [downloadable]="false"
                                        [baseMapUrl]="baseMapUrl"
                                        [height]="size4">
                                    </geo-map-card>
                                </div>
                            </div>
                            <div class="gap"></div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <geo-map-card
                                        title="La Réunion"
                                        [geometries]="reunionGeometries()"
                                        [isLoading]="cracMapData().length == 0"
                                        [error]="reunionGeometries().length === 0"
                                        [getStyle]="getMapStyle"
                                        [mapId]="'reunionMapId'"
                                        [getTooltip]="getTooltip"
                                        [zoomable]="false"
                                        [downloadable]="false"
                                        [baseMapUrl]="baseMapUrl"
                                        [height]="size4">
                                    </geo-map-card>
                                </div>
                            </div>
                            <div class="gap"></div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <geo-map-card
                                        title="Guyane"
                                        [geometries]="guyaneGeometries()"
                                        [isLoading]="cracMapData().length == 0"
                                        [error]="guyaneGeometries().length === 0"
                                        [getStyle]="getMapStyle"
                                        [mapId]="'guyaneMapId'"
                                        [getTooltip]="getTooltip"
                                        [zoomable]="false"
                                        [downloadable]="false"
                                        [baseMapUrl]="baseMapUrl"
                                        [height]="size4">
                                    </geo-map-card>
                                </div>
                            </div>
                            <div class="gap"></div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <geo-map-card
                                        title="Mayotte"
                                        [geometries]="mayotteGeometries()"
                                        [isLoading]="cracMapData().length == 0"
                                        [error]="mayotteGeometries().length === 0"
                                        [getStyle]="getMapStyle"
                                        [mapId]="'mayotteMapId'"
                                        [getTooltip]="getTooltip"
                                        [zoomable]="false"
                                        [downloadable]="false"
                                        [baseMapUrl]="baseMapUrl"
                                        [height]="size4">
                                    </geo-map-card>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="gap"></div>
                    <div class="row">
                        <div class="col-sm-12">
                            <generic-card [isLoading]="cracMapData().length == 0">
                                <span class="text-calltoaction">
                                    {{ callToActionText }}
                                </span>
                            </generic-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
